export default __webpack_public_path__ + "static/media/logout-line.9370d9ed.svg";